import { AUTHORITIES } from 'common/constants';
import { useClient } from 'components/ClientProvider';
import { useFetchPrintersWithCheckNo } from 'hooks/useClientDataServices';
import { useAppSelector } from 'store/hooks';
import { getArchiveOnly, getInterCompanyCIBAccount } from '../slice';
import { DifferentCheckNo } from './DifferentCheckNo';
import { mapPermissionsToAuthorities, checkAuthorities } from './helpers';
import { PrinterContent } from './PrinterContent';
import { getIsMICRPrinter } from './slice';

export const CheckSequence = ({
  setCheckNoInputValue,
  checkNoInputValue,
  setIsRadioOptionEnabled,
  cashCompanyStoreid
}: {
  setCheckNoInputValue: (value: string) => void;
  checkNoInputValue: string;
  setIsRadioOptionEnabled: (value: boolean) => void;
  cashCompanyStoreid: string;
}): React.JSX.Element => {
  const userInfo = useClient();
  const interCompanyCIBAccount = useAppSelector(getInterCompanyCIBAccount);
  const userPermissions = userInfo?.customClientValues?.permissions;
  const {
    data: defaultPrinterDetails,
    isFetching,
    isError
  } = useFetchPrintersWithCheckNo(
    interCompanyCIBAccount.accountNumber,
    cashCompanyStoreid
  );

  const isMICRPrinter = useAppSelector(getIsMICRPrinter);
  const archiveOnly = useAppSelector(getArchiveOnly);

  const updatedPermission = mapPermissionsToAuthorities(userPermissions);

  const userCanUpdateCheckNo = checkAuthorities(
    updatedPermission,
    AUTHORITIES.UPDATE_CHECK_NUMBER_AP_CHECK
  );

  return (
    <>
      <PrinterContent
        defaultPrinterDetails={defaultPrinterDetails}
        isPrinterLoading={isFetching}
        isError={isError}
      />
      {(archiveOnly || !isMICRPrinter) && userCanUpdateCheckNo && (
        <DifferentCheckNo
          setIsRadioOptionEnabled={setIsRadioOptionEnabled}
          setCheckNoInputValue={setCheckNoInputValue}
          checkNoInputValue={checkNoInputValue}
        />
      )}
    </>
  );
};
